import React from 'react'

interface ISelectLocationButton {
    selectedLocation: any;
    setOpenOrderModal: (state: boolean) => void;
}

const SelectLocationButton: React.FC<ISelectLocationButton> = ({ selectedLocation, setOpenOrderModal }) => {
    return (
        <React.Fragment>
            {!selectedLocation &&
                <button
                    type="button"
                    className="btn btn-large mb-sm-4 mb-3 d-block mx-auto"
                    onClick={() => {
                        setOpenOrderModal(true)
                    }}
                >
                    Select A Location
                </button>
            }
        </React.Fragment>
    )
}

export default SelectLocationButton